export default __webpack_public_path__ + "static/media/nano energy.4528388f.png";